import 'css-chunksrc/client/pages/occupancyPage/table/row/styles.scss';export default {
  "resourceRow": "_resourceRow_1ruvz_1",
  "withMonthRow": "_withMonthRow_1ruvz_9",
  "resourceCell": "_resourceCell_1ruvz_13",
  "clickable": "_clickable_1ruvz_29",
  "chevronBox": "_chevronBox_1ruvz_33",
  "identityGroup": "_identityGroup_1ruvz_41",
  "avatar": "_avatar_1ruvz_50",
  "identity": "_identity_1ruvz_41",
  "name": "_name_1ruvz_60",
  "profession": "_profession_1ruvz_69"
};